import React, { useState, useEffect,useContext } from "react";
import { Grid, Card, CardContent, Typography, Box,Button,CardMedia } from "@mui/material";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import "../HRView/HRview.css";
import config from "config/config";
import Context from "context/context";
import { toast } from "react-toastify";
import ReusableTable from "components/table/table";
import Tooltip from '@mui/material/Tooltip';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import selfassessment from 'assets/images/selfassesment.png'
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Modal } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import Chart from "chart.js/auto";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";

import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';



import {
    
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    
  } from "@mui/material";

const ManagerReport = () => {
    
    const [employeeCycles, setEmployeeCycles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // const [selectedCycle, setSelectedCycle] = useState(null);
    const [templateData, setTemplateData] = useState([]);
    const [isTemplateLoading, setIsTemplateLoading] = useState(false);
    const [count, setCount] = useState(0);
    const [offset, setOffset] = useState(1);
    const [searchValue, setSearchValue] = useState("");
    const [formattedTemplateData, setFormattedTemplateData] = useState([]);
    const [assignedGoals, setAssignedGoals] = useState([]);
    const { state, dispatch } = useContext(Context);
  const [filterType, setFilterType] = useState("");
  const [extraFilterOptions, setExtraFilterOptions] = useState([]);
  const [extraFilter, setExtraFilter] = useState("");
  const [reportType, setReportType] = useState(""); 
  const [selectedCategory, setSelectedCategory] = useState("");
  const[isCategoryEnabled,setIsCategoryEnabled]=useState("")
  const [searchTerm, setSearchTerm] = useState(""); // For searching
  const [searchCategoryTerm, setSearchCategoryTerm] = useState(""); 
  const [tableDataModal, setTableDataModal] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selfAssessmentData, setSelfAssessmentData] = useState(null);
  const [reviewAssessmentData, setReviewAssessmentData] = useState(null)
  const limit = 10;

  const reportOptions = [
    "Overall Rating",
    "Year-End Rating",
    "Manager Review Status",
    "Self-Assessment Status",
  ];
  const currentYear = new Date().getFullYear().toString();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedCycle, setSelectedCycle] = useState("Q1");

  // Handle changes to year dropdown
  const handleYearChange = (event) => {
    console.log("Event value received:", event.target.value); // Debugging the value
    const year = event.target.value; // No conversion unless needed
    console.log("Extracted Year as String:", year);

    setSelectedYear(year);

    // Debugging - Toast to confirm
  };

  const yearOptions = Array.from({ length: parseInt(currentYear) - 2000 + 1 }, (_, index) =>
    (2000 + index).toString()
  );
  // Handle changes to cycle dropdown
  const handleCycleChange = (event) => {
    const cycle = event.target.value; // Extract the selected value
    setSelectedCycle(cycle);
  };
  const categoryOptions = ["Manager Review Status", "Employee Assessment Status"];

  const filterOptions = ["All", "Employees"];

    const defaultCycles = ["Q1", "Q2", "Q3", "Q4", "Yearly"];

    const filteredOptions = extraFilterOptions.filter((option) => {
      const searchValue =
        filterType === "Manager"
          ? option.managerName
          : filterType === "Department"
          ? option.deptName
          : `${option.employeeCode} - ${option.firstName}`;
      return searchValue?.toLowerCase().includes(searchTerm.toLowerCase());
    });
    useEffect(() => {
      fetchAppraisalCycles();
    }, []);

    useEffect(() => {
      // Fetch Self Assessment Data
      const fetchSelfAssessmentData = async () => {
        dispatch({ type: "SET_LOADING", payload: true });

        try {
          const url = `${config.host}/panel/pms/charts/selfAssessment`;
          const response = await fetch(url, {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          });
  
          if (!response.ok) {
            throw new Error("Error fetching self-assessment data");
            dispatch({ type: "SET_LOADING", payload: false });

          }
  
          const data = await response.json();
          if (data.type === "SUCCESS") {
            const { completedEmployeeAssessmentCount, totalEmployeeCount } =
              data.data[0];
            setSelfAssessmentData({
              data: {
                labels: ["Completed", "Remaining"],
                datasets: [
                  {
                    data: [
                      parseInt(completedEmployeeAssessmentCount, 10),
                      parseInt(totalEmployeeCount, 10) -
                        parseInt(completedEmployeeAssessmentCount, 10),
                    ],
                    backgroundColor: ["#4CAF50", "#FF5733"], // Colors
                  },
                ],
              },
              options: {
                plugins: {
                  centerText: {
                    text: `${completedEmployeeAssessmentCount}/${totalEmployeeCount}`,
                  },
                },
                cutout: "70%", // Donut hole
              },
            });
            dispatch({ type: "SET_LOADING", payload: false });

          }
        } catch (error) {
          console.error("Error fetching self-assessment data:", error);
          dispatch({ type: "SET_LOADING", payload: false });

        }
      };
  
      // Fetch Review Assessment Data
      const fetchReviewAssessmentData = async () => {
        dispatch({ type: "SET_LOADING", payload: true });

        try {
          const url = `${config.host}/panel/pms/charts/managerReview`;
          const response = await fetch(url, {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          });
  
          if (!response.ok) {
            throw new Error("Error fetching review assessment data");
            dispatch({ type: "SET_LOADING", payload: false });

          }
  
          const data = await response.json();
          if (data.type === "SUCCESS") {
            const { completedManagerReviewCount, totalEmployeeCount } =
              data.data[0];
            setReviewAssessmentData({
              data: {
                labels: ["Completed", "Remaining"],
                datasets: [
                  {
                    data: [
                      parseInt(completedManagerReviewCount, 10),
                      parseInt(totalEmployeeCount, 10) -
                        parseInt(completedManagerReviewCount, 10),
                    ],
                    backgroundColor: ["#4CAF50", "#FF5733"], // Colors
                  },
                ],
              },
              options: {
                plugins: {
                  centerText: {
                    text: `${completedManagerReviewCount}/${totalEmployeeCount}`,
                  },
                },
                cutout: "70%", // Donut hole
              },
            });
            dispatch({ type: "SET_LOADING", payload: false });

          }
        } catch (error) {
          console.error("Error fetching review assessment data:", error);
          dispatch({ type: "SET_LOADING", payload: false });

        }
      };
  
      fetchSelfAssessmentData();
      fetchReviewAssessmentData();
    }, []);
  


    function showReportModal(data) {
      dispatch({ type: "SET_LOADING", payload: true });

      console.log("data in the modal", data);
      console.log("report type in modal", reportType);
      let mappedData = [];
      if (!data?.data?.result || !Array.isArray(data.data.result)) {
        console.error("Data structure is invalid. No data to map.");
        return;
      }
      switch (reportType) {
        case "Overall Rating":
          if (Array.isArray(data?.data?.result)) {
          mappedData = data?.data?.result?.map((item, index) =>[
            
            index + 1 + (offset - 1) * limit,
            item.employeeCode,
            item.firstName,
            item.cycleName,
            item.overAllRatings,
        ])
      } else {
        console.error("Expected data?.data?.result to be an array but it's not.");
      }
      dispatch({ type: "SET_LOADING", payload: false });

          break;
    
        case "Year-End Rating":
          if (Array.isArray(data?.data?.result)) {
          mappedData = data?.data?.result?.map((item, index) => [
           
            index + 1 + (offset - 1) * limit,
            item.employeeCode,
            item.firstName,
            item.Q1Rating,
            item.Q2Rating,
            item.Q3Rating,
            item.Q4Rating,
            item.yearEndRating,
            item.finalHrRating,
          ]);
        } else {
          console.error("Expected data?.data?.result to be an array but it's not.");
        }
        dispatch({ type: "SET_LOADING", payload: false });

          break;
    
        case "Non-Compliance Report":
          if (Array.isArray(data?.data?.result)) {
            mappedData = data.data.result.map((item, index) => [
              index + 1 + (offset - 1) * limit,
              item.employeeCode,
              item.firstName,
              item.managerReviewStatus,
             
            ]);
          } else {
            console.error("Expected data?.data?.result to be an array but it's not.");
          }
          dispatch({ type: "SET_LOADING", payload: false });

          break;
          
    
        case "Manager Review Status":
          if (Array.isArray(data?.data?.result)) {
            mappedData = data.data.result.map((item, index) => [
              index + 1 + (offset - 1) * limit,
              item.employeeCode,
              item.firstName,
              item.cycleName,
              item.managerReviewStatus,
             
            ]);
          } else {
            console.error("Expected data?.data?.result to be an array but it's not.");
          }
          dispatch({ type: "SET_LOADING", payload: false });

          break;
    
        case "Self-Assessment Status":
          if (Array.isArray(data?.data?.result)) {
            mappedData = data.data.result.map((item, index) => [
              index + 1 + (offset - 1) * limit,
              item.employeeCode,
              item.firstName,
              item.cycleName,
              item.employeeAssessmentStatus,
              
            ]);
          } else {
            console.error("Expected data?.data?.result to be an array but it's not.");
          }
          dispatch({ type: "SET_LOADING", payload: false });

          break;
    
        default:
          dispatch({ type: "SET_LOADING", payload: false });

          console.error("Unhandled report type");
        
          
      }
    
      setTableDataModal(mappedData);
      console.log("Mapped data for the modal length:", mappedData.length);
      setIsModalVisible(true);
    }

    const handleModalClose = () => {
      setIsModalVisible(false);
    };
    
  
  
    const fetchAppraisalCycles = async () => {
      try {
        dispatch({ type: "SET_LOADING", payload: true });
        const url = `${config.host}/panel/pms/employee/allAppraisalCycles`;
        const response = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });
  
        if (!response.ok) {
          throw new Error("Error fetching appraisal cycles");
          dispatch({ type: "SET_LOADING", payload: false });
        }
  
        const data = await response.json();
  
        if (data.status === "Ok" && Array.isArray(data.data.employeeCycles)) {
          const sortedCycles = defaultCycles
            .map((cycleName) =>
              data.data.employeeCycles.find((item) => item.cycleName === cycleName)
            )
            .filter(Boolean); 
          setEmployeeCycles(sortedCycles);
          dispatch({ type: "SET_LOADING", payload: false });
        } else {
          console.error("Unexpected data format:", data);
        }
      } catch (error) {
        console.error("Error fetching appraisal cycles:", error);
        dispatch({ type: "SET_LOADING", payload: false });
      } finally {
        dispatch({ type: "SET_LOADING", payload: false });
      }
    };


    useEffect(() => {
      const fetchData = async () => {
        let fetchedData = [];
        if (filterType === "Manager") {
          fetchedData = await fetchManagerList();
        } else if (filterType === "Employees") {
          fetchedData = await fetchEmployeeList();
        } else if (filterType === "Department") {
          fetchedData = await fetchDepartmentList();
        }
        setExtraFilterOptions(fetchedData);
      };
    
      if (filterType) {
        fetchData();
      }
    }, [filterType]);

    const fetchManagerList = async () => {
      dispatch({ type: "SET_LOADING", payload: true });

      try {
        const url = `${config.host}/panel/pms/reports/managerList`;
        const response = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });
    
        if (!response.ok) {
          throw new Error("Error fetching manager list");
          dispatch({ type: "SET_LOADING", payload: false });

        }
    
        const data = await response.json();
    
        if (data.type === "SUCCESS" && Array.isArray(data.data)) {
          dispatch({ type: "SET_LOADING", payload: false });
          return data.data; // Returns manager list
          

        } else {
          console.error("Unexpected data format:", data);
          dispatch({ type: "SET_LOADING", payload: false });

          return [];
        }
      } catch (error) {
        console.error("Error fetching manager list:", error);
        dispatch({ type: "SET_LOADING", payload: false });
        return [];
      }
    };
    
    const fetchEmployeeList = async () => {
      dispatch({ type: "SET_LOADING", payload: true });

      try {
        const url = `${config.host}/panel/pms/reports/employeesList`;
        const response = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });
    
        if (!response.ok) {
          throw new Error("Error fetching employee list");
          dispatch({ type: "SET_LOADING", payload: false });

        }
    
        const data = await response.json();
    
        if (data.type === "SUCCESS" && Array.isArray(data.data)) {
          dispatch({ type: "SET_LOADING", payload: false });
          return data.data;

          

        } else {
          console.error("Unexpected data format:", data);
          dispatch({ type: "SET_LOADING", payload: false });

          return [];
        }
      } catch (error) {
        console.error("Error fetching employee list:", error);
        dispatch({ type: "SET_LOADING", payload: false });

        return [];
      }
    };
    
    const fetchDepartmentList = async () => {
      dispatch({ type: "SET_LOADING", payload: true });

      try {
        const url = `${config.host}/panel/pms/reports/deptsList`;
        const response = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });
    
        if (!response.ok) {
          throw new Error("Error fetching department list");
          dispatch({ type: "SET_LOADING", payload: false });

        }
    
        const data = await response.json();
    
        if (data.type === "SUCCESS" && Array.isArray(data.data)) {
          return data.data; // Returns department list
          dispatch({ type: "SET_LOADING", payload: false });

        } else {
          console.error("Unexpected data format:", data);
          dispatch({ type: "SET_LOADING", payload: false });

          return [];
        }
      } catch (error) {
        console.error("Error fetching department list:", error);
        dispatch({ type: "SET_LOADING", payload: false });

        return [];
      }
    };

    useEffect(() => {
        console.log("offset", offset);
      
        // Ensure required dependencies are valid before calling handleViewReport
        if (
          offset !== null &&
          offset !== undefined &&
          reportType && // Ensure reportType is defined
          filterType && // Ensure filterType is defined
          (filterType === "All" || extraFilter) && // Validate extraFilter if filterType is not "All"
          (!isCategoryEnabled || selectedCategory) // Validate selectedCategory if category is enabled
        ) {
          handleViewReport();
        }
      }, [offset]);
      
    const closeModal = () => {
      handleModalClose(false);
      setOffset("1")
      setExtraFilter("")
      setReportType("")
        setSelectedCategory("")
        setFilterType("")
      
    };

    
    useEffect(() => {
      console.log("count",count)
    }, [count]);

    async function handleViewReport() {
      if (!reportType) {
        toast.error("Please select a Report Type");
        return;
      }
      if (!filterType) {
        toast.error("Please select a Filter");
        return;
      }
      if (filterType && filterType !== "All" && !extraFilter) {
        toast.error(`Please select ${filterType}`);
        return;
      }
      if (isCategoryEnabled && !selectedCategory) {
        toast.error("Please select a Category");
        return;
      }
      dispatch({ type: "SET_LOADING", payload: true });

      console.log(reportType)
      console.log(extraFilter)
      let endpoint = "";
      let payload = null;

      const basePayload = {
        offset: (offset - 1) * limit, // Pagination offset logic
        limit: limit,                 // Rows per page
               // Search string
      };
    
      switch (reportType) {
        case "Non-Compliance Report":
          endpoint = `${config.host}/panel/pms/reports/nonComplainceReportview`;
          if (filterType === "Employees" && extraFilter) {
            payload = {
              ...basePayload,
              employeeIds: [extraFilter], // Pass the selected employee ID
              category: selectedCategory === "Employee Assessment Status"
              ? "employeeAssessmentStatus"
              : selectedCategory === "Manager Review Status"
              ? "managerReviewStatus"
              : null, // Handle other cases if needed
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Manager" && extraFilter) {
            payload = {
              ...basePayload,
              managerIds: [extraFilter], // Pass the selected manager ID
              category: selectedCategory === "Employee Assessment Status"
              ? "employeeAssessmentStatus"
              : selectedCategory === "Manager Review Status"
              ? "managerReviewStatus"
              : null, // Handle other cases if needed
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Department" && extraFilter) {
            payload = {
              ...basePayload,
              roleIds: [extraFilter], // Pass the selected department ID
              category: selectedCategory === "Employee Assessment Status"
              ? "employeeAssessmentStatus"
              : selectedCategory === "Manager Review Status"
              ? "managerReviewStatus"
              : null, // Handle other cases if needed
              year: selectedYear,
              cycleName:selectedCycle,
            };
          }else if (filterType === "All" ) {
            payload = {
              ...basePayload,
               // Pass the selected department ID
               category: selectedCategory === "Employee Assessment Status"
              ? "employeeAssessmentStatus"
              : selectedCategory === "Manager Review Status"
              ? "managerReviewStatus"
              : null,
              year: selectedYear,
            cycleName:selectedCycle,
            };
          }
         
          break;
    
        case "Year-End Rating":
          endpoint = `${config.host}/panel/pms/reports/yearEndRatingReportView`;
          if (filterType === "Employees" && extraFilter) {
            payload = {
              ...basePayload,
              employeeIds: [extraFilter], // Pass the selected employee ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Manager" && extraFilter) {
            payload = {
              ...basePayload,
              managerIds: [extraFilter], // Pass the selected manager ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Department" && extraFilter) {
            payload = {
              ...basePayload,
              roleIds: [extraFilter], // Pass the selected department ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          }else if (filterType === "All" ) {
            payload = {
              ...basePayload,
               // Pass the selected department ID
              year: selectedYear,
            cycleName:selectedCycle,
            };
          }
          break;
    
          case "Overall Rating":
            endpoint = `${config.host}/panel/pms/reports/overAllRatingReportView`;
            if (filterType === "Employees" && extraFilter) {
              payload = {
                ...basePayload,
                employeeIds: [extraFilter], // Pass the selected employee ID
                year: selectedYear,
              cycleName:selectedCycle,
              };
            } else if (filterType === "Manager" && extraFilter) {
              payload = {
                ...basePayload,
                managerIds: [extraFilter], // Pass the selected manager ID
                year: selectedYear,
              cycleName:selectedCycle,
              };
            } else if (filterType === "Department" && extraFilter) {
              payload = {
                ...basePayload,
                roleIds: [extraFilter], // Pass the selected department ID
                year: selectedYear,
              cycleName:selectedCycle,
              };
            }
            else if (filterType === "All" ) {
              payload = {
                ...basePayload,
                 // Pass the selected department ID
                year: selectedYear,
              cycleName:selectedCycle,
              };
            }
            break;
    
        case "Manager Review Status":
          endpoint = `${config.host}/panel/pms/reports/reviewStatusReportView`;
          if (filterType === "Employees" && extraFilter) {
            payload = {
              ...basePayload,
              employeeIds: [extraFilter], // Pass the selected employee ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Manager" && extraFilter) {
            payload = {
              ...basePayload,
              managerIds: [extraFilter], // Pass the selected manager ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Department" && extraFilter) {
            payload = {
              ...basePayload,
              roleIds: [extraFilter], // Pass the selected department ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          }else if (filterType === "All" ) {
            payload = {
              ...basePayload,
               // Pass the selected department ID
              year: selectedYear,
            cycleName:selectedCycle,
            };
          }
          break;
    
        case "Self-Assessment Status":
          endpoint = `${config.host}/panel/pms/reports/assessmentStatusReportView`;
          if (filterType === "Employees" && extraFilter) {
            payload = {
              ...basePayload,
              employeeIds: [extraFilter], // Pass the selected employee ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Manager" && extraFilter) {
            payload = {
              ...basePayload,
              managerIds: [extraFilter], // Pass the selected manager ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Department" && extraFilter) {
            payload = {
              ...basePayload,
              roleIds: [extraFilter], // Pass the selected department ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          }else if (filterType === "All" ) {
            payload = {
              ...basePayload,
               // Pass the selected department ID
              year: selectedYear,
            cycleName:selectedCycle,
            };
          }
          break;
    
        default:
          console.error("Invalid report type");
          return;
      }
    
      try {
        const options = {
          method: "POST",
          credentials: "include", // Send cookies if authenticated
          headers: {
            "Content-Type": "application/json",
          },
          body: payload ? JSON.stringify(payload) : null, // Only include payload if set
        };
    
        const response = await fetch(endpoint, options);
    
        if (!response.ok) {
          throw new Error(`Failed to fetch data: ${response.statusText}`);
          dispatch({ type: "SET_LOADING", payload: false });

        }
    
        const data = await response.json();
        console.log("API Response Data: ", data);
        if (data?.data?.count?.count) {
          setCount(parseInt(data.data.count.count, 10)); // Parse and set the count
          dispatch({ type: "SET_LOADING", payload: false });

        }
    
        // Display the results in modal
        showReportModal(data);
      } catch (error) {
        console.error("Error fetching report data: ", error);
        dispatch({ type: "SET_LOADING", payload: false });

      }
    }




    async function handleExportReport() {
        if (!reportType) {
            toast.error("Please select a Report Type");
            return;
          }
          if (!filterType) {
            toast.error("Please select a Filter");
            return;
          }
          if (filterType && filterType !== "All" && !extraFilter) {
            toast.error(`Please select ${filterType}`);
            return;
          }
          if (isCategoryEnabled && !selectedCategory) {
            toast.error("Please select a Category");
            return;
          }
      dispatch({ type: "SET_LOADING", payload: true });

      console.log(reportType)
      console.log(extraFilter)
      let endpoint = "";
      let payload = null;
    
      switch (reportType) {
        case "Non-Compliance Report":
          endpoint = `${config.host}/panel/pms/reports/nonComplainceReport`;
          if (filterType === "Employees" && extraFilter) {
            payload = {
              employeeIds: [extraFilter], // Pass the selected employee ID
              category: selectedCategory === "Employee Assessment Status"
              ? "employeeAssessmentStatus"
              : selectedCategory === "Manager Review Status"
              ? "managerReviewStatus"
              : null, // Handle other cases if needed
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Manager" && extraFilter) {
            payload = {
              managerIds: [extraFilter], // Pass the selected manager ID
              category: selectedCategory === "Employee Assessment Status"
              ? "employeeAssessmentStatus"
              : selectedCategory === "Manager Review Status"
              ? "managerReviewStatus"
              : null, // Handle other cases if needed
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Department" && extraFilter) {
            payload = {
              roleIds: [extraFilter], // Pass the selected department ID
              category: selectedCategory === "Employee Assessment Status"
              ? "employeeAssessmentStatus"
              : selectedCategory === "Manager Review Status"
              ? "managerReviewStatus"
              : null, // Handle other cases if needed
              year: selectedYear,
              cycleName:selectedCycle,
            };
          }
         
          break;
    
        case "Year-End Rating":
          endpoint = `${config.host}/panel/pms/reports/yearEndRatingReport`;
          if (filterType === "Employees" && extraFilter) {
            payload = {
              employeeIds: [extraFilter], // Pass the selected employee ID
              
            };
          } else if (filterType === "Manager" && extraFilter) {
            payload = {
              managerIds: [extraFilter], // Pass the selected manager ID
             
            };
          } else if (filterType === "Department" && extraFilter) {
            payload = {
              roleIds: [extraFilter], // Pass the selected department ID
              
            };
          }
          break;
    
          case "Overall Rating":
            endpoint = `${config.host}/panel/pms/reports/overAllRatingReport`;
            if (filterType === "Employees" && extraFilter) {
              payload = {
                employeeIds: [extraFilter], // Pass the selected employee ID
                year: selectedYear,
              cycleName:selectedCycle,
              };
            } else if (filterType === "Manager" && extraFilter) {
              payload = {
                managerIds: [extraFilter], // Pass the selected manager ID
                year: selectedYear,
              cycleName:selectedCycle,
              };
            } else if (filterType === "Department" && extraFilter) {
              payload = {
                roleIds: [extraFilter], // Pass the selected department ID
                year: selectedYear,
              cycleName:selectedCycle,
              };
            }
            break;
    
        case "Manager Review Status":
          endpoint = `${config.host}/panel/pms/reports/reviewStatusReport`;
          if (filterType === "Employees" && extraFilter) {
            payload = {
              employeeIds: [extraFilter], // Pass the selected employee ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Manager" && extraFilter) {
            payload = {
              managerIds: [extraFilter], // Pass the selected manager ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Department" && extraFilter) {
            payload = {
              roleIds: [extraFilter], // Pass the selected department ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          }
          break;
    
        case "Self-Assessment Status":
          endpoint = `${config.host}/panel/pms/reports/assessmentStatusReport`;
          if (filterType === "Employees" && extraFilter) {
            payload = {
              employeeIds: [extraFilter], // Pass the selected employee ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Manager" && extraFilter) {
            payload = {
              managerIds: [extraFilter], // Pass the selected manager ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          } else if (filterType === "Department" && extraFilter) {
            payload = {
              roleIds: [extraFilter], // Pass the selected department ID
              year: selectedYear,
              cycleName:selectedCycle,
            };
          }
          break;
    
        default:
          console.error("Invalid report type");
          return;
      }
    
      try {
        const options = {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: payload ? JSON.stringify(payload) : null,
        };
    
        const response = await fetch(endpoint, options);
        if (response.ok) {
          try {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
        
            link.href = url;
            link.setAttribute("download", `${reportType}.xlsx`);
            document.body.appendChild(link);
      
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
      
            toast.success("File Downloaded Successfully", {
              toastId: "file-success",
            });
            dispatch({ type: "SET_LOADING", payload: false });

          } catch (error) {
            console.error('Error during response processing: ', error);
            dispatch({ type: "SET_LOADING", payload: false });

            toast.error("Error processing file download", { toastId: "processing-error" });
          }
        } else {
          console.error('Response not OK: ', response.status, response.statusText);
          dispatch({ type: "SET_LOADING", payload: false });

          toast.error(`Error: ${response.statusText}`, { toastId: "response-error" });
        }
      } catch (error) {
        console.error('Unexpected error: ', error);
        dispatch({ type: "SET_LOADING", payload: false });

        toast.error("An unexpected error occurred", { toastId: "unexpected-error" });
      }
    }
    // Function to handle modal rendering
    
    
    
  
  
      
    const handleReportTypeClick = (e) => {
      const selectedReportType = e.target.value;
      console.log('reportType selected:', e.target.value);
      setReportType(e.target.value)

      if (selectedReportType === "Non-Compliance Report") {
        setIsCategoryEnabled(true);
      } else {
        setIsCategoryEnabled(false);
        setFilterType("");
        setSelectedCategory("");
      }
    };
   
  
    return (
      <>
      <Box
        sx={{
          padding: 4,
          backgroundColor: "#f9f9f9",
          borderRadius: 2,
          boxShadow: 1,
        }}
      >
       <Typography variant="h5" align="center" className="self-title" sx={{ mb: 4 }}>
        Performance Appraisal Reports
      </Typography>
    

      <Grid container spacing={3}>
  {/* Self Assessment Chart Section */}
  {selfAssessmentData && (
    <Grid item xs={12} sm={6}>
      <Card
        className="card-style"
        elevation={2}
        style={{
          borderRadius: "10px",
          border: "1px solid #E0E0E0", // Light border for subtle separation
        }}
      >
        <CardContent>
          <Typography
            variant="h6"
            component="div"
            style={{
              textAlign: "center",
              marginBottom: "20px",
              padding: "10px",
              fontWeight: "600",
              fontSize: "1.1rem",
              borderBottom: "1px solid #E0E0E0", // Subtle divider
              color: "#333333", // Neutral text color
            }}
          >
            Self Assessment
          </Typography>
          <div
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "280px",
              height: "280px",
              margin: "0 auto",
            }}
          >
            <Doughnut
              data={selfAssessmentData.data}
              options={selfAssessmentData.options}
            />
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
                fontSize: "16px",
                fontWeight: "500",
                color: "#555555", // Neutral center text
              }}
            >
              {selfAssessmentData.options.plugins.centerText.text}
            </div>
          </div>
        </CardContent>
      </Card>
    </Grid>
  )}

  {/* Review Assessment Chart Section */}
  {reviewAssessmentData && (
    <Grid item xs={12} sm={6}>
      <Card
        className="card-style"
        elevation={2}
        style={{
          borderRadius: "10px",
          border: "1px solid #E0E0E0", // Light border for subtle separation
        }}
      >
        <CardContent>
          <Typography
            variant="h6"
            component="div"
            style={{
              textAlign: "center",
              marginBottom: "20px",
              padding: "10px",
              fontWeight: "600",
              fontSize: "1.1rem",
              borderBottom: "1px solid #E0E0E0", // Subtle divider
              color: "#333333", // Neutral text color
            }}
          >
            Review Assessment
          </Typography>
          <div
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "280px",
              height: "280px",
              margin: "0 auto",
            }}
          >
            <Doughnut
              data={reviewAssessmentData.data}
              options={reviewAssessmentData.options}
            />
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
                fontSize: "16px",
                fontWeight: "500",
                color: "#555555", // Neutral center text
              }}
            >
              {reviewAssessmentData.options.plugins.centerText.text}
            </div>
          </div>
        </CardContent>
      </Card>
    </Grid>
  )}
</Grid>






      <Box sx={{ padding: 2 }} spacing={2} style={{ marginTop: '5%'}}>
      {/* <Grid item xs={12} spacing={2} >
    Reports
  </Grid> */}
      <Grid container justifyContent="flex-end" spacing={2}>
        {/* Dropdown for Year */}
        <Grid item>
          <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Year</InputLabel>
            <Select
              value={selectedYear} // Controlled value
              onChange={handleYearChange} // Trigger handler
              label="Year"
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300, // Enable scrolling for dropdown
                    overflowY: "auto",
                  },
                },
              }}
            >
              {yearOptions.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Dropdown for Cycle */}
        
        <Grid item>
          <FormControl variant="outlined" size="small">
            <InputLabel>Cycle</InputLabel>
            <Select
              value={selectedCycle}
              onChange={handleCycleChange}
              label="Cycle"
              MenuProps={{ disableScrollLock: true }}
              sx={{ width: 100 }}
            >
              {["Q1", "Q2", "Q3", "Q4"].map((cycle) => (
                <MenuItem key={cycle} value={cycle}>
                  {cycle}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>

      <Grid container spacing={2}>
        {/* Report Type Dropdown */}
        <Grid item xs={12} sm={6}>
          <Box className="label">Report Type<span style={{ color: "red" }}>*</span></Box>
          <FormControl fullWidth>
  {/* <InputLabel id="report-type-label">Report Type</InputLabel> */}
  <Select
    labelId="report-type-label"
    id="report-type-select"
    value={reportType}
    onChange={handleReportTypeClick}
    displayEmpty

  >
<MenuItem value="" disabled style={{ color: "grey" }}>
        Select Report Type
      </MenuItem>
              {reportOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
    ))}
  </Select>
</FormControl>

        </Grid>

        {/* Filter Dropdown */}
      {/* Conditionally Render Filter or Category Dropdown */}
<Grid item xs={12} sm={6}>
  <Box className="label">
    Filter<span style={{ color: "red" }}>*</span>
  </Box>
  <FormControl fullWidth>
    
      <Select
        value={filterType}
        onChange={(e) => setFilterType(e.target.value)}
        displayEmpty

      >
        <MenuItem value="" disabled>
          Select Filter
        </MenuItem>
        {filterOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    
  </FormControl>
</Grid>


        
{filterType && filterType !== "All" && (
  <Grid item xs={12} sm={6}>
    <Box className="label">{`Select ${filterType}`}<span style={{ color: "red" }}>*</span></Box>
    <FormControl fullWidth>
    <Select
  value={extraFilter}
  onChange={(e) => {
    const value = e.target.value; // Selected employee ID or other option value
    setExtraFilter(value);
  }}
  displayEmpty
  
  style={{ border: "2px solid #B2D6F8", color: "grey" }}
>
  <MenuItem value="" disabled>
    Select {filterType}
    
  </MenuItem>
  {extraFilterOptions.map((option) => (
      <MenuItem
      key={option.employeeId || option.managerId || option.deptId} // Ensure a unique key
      value={
        filterType === "Manager"
          ? option.managerId
          : filterType === "Department"
          ? option.deptId
          : option.employeeId
      } // Send the appropriate ID
    >
{filterType === "Manager"
        ? option.managerName || "Unknown Manager"
        : filterType === "Department"
        ? option.deptName || "Unknown Department"
        : option.employeeCode && option.firstName
        ? `${option.employeeCode} - ${option.firstName}`
        : "Unknown Employee"}    </MenuItem>
  ))}
</Select>



    </FormControl>
  </Grid>

  

  
)}
 {/* Conditionally Render Filter or Category Dropdown */}
 {isCategoryEnabled && (
 <Grid item xs={12} sm={6}>
  <Box className="label">
    Category<span style={{ color: "red" }}>*</span>
  </Box>
  <FormControl fullWidth>
    
      <Select
        value={selectedCategory}
        onChange={(e) => setSelectedCategory(e.target.value)}
        displayEmpty

      >
        <MenuItem value="" disabled>
          Select Category
        </MenuItem>
        {categoryOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
     
  </FormControl>
</Grid>
)}

      </Grid>

      {/* <Grid container spacing={2} sx={{ mt: 4 }}>
        <Grid item xs={6}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<DownloadIcon />}
            fullWidth
            onClick={handleExportReport}
          >
            Download
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<VisibilityIcon />}
            fullWidth
            onClick={handleViewReport}
          >
            View
          </Button>
        </Grid>
      </Grid> */}
      <Grid container style={{ marginTop: "30px", marginBottom: "40px" }}>
        <Grid item xs={12} style={{ textAlign: "right", padding: "20px 0px" }}>

        <Button
            className="download-btn"
            sx={{marginRight:'10px'}}
            startIcon={
              <RemoveRedEyeOutlinedIcon
                style={{ fontSize: 30, verticalAlign: "middle" ,pl:'2px'}}
              />
            }
            onClick={handleViewReport}
          >
            View
          </Button>
          <Button
            className="download-btn"
            startIcon={
              <DownloadForOfflineIcon
                style={{ fontSize: 30, verticalAlign: "middle" }}
              />
            }
            onClick={handleExportReport}
          >
            Export
          </Button>
        </Grid>
      </Grid>
      {/* <Modal
  visible={isModalVisible}
  onCancel={handleModalClose}
  footer={null}
  title="Report Data"
>
  {tableDataModal.length > 0 ? (
    <ReusableTable
      data={tableDataModal}
      count={tableDataModal.length}
      offset={offset}
      setOffset={setOffset}
      limit="25"
      setSearchValue={setSearchValue}
      heading={["S.No", "Employee Code", "First Name", "Cycle Name", "Manager Review Status"]}
    />
  ) : (
    <div>No data available to show</div>
  )}
</Modal> */}

 
    </Box>
    <Modal
  open={isModalVisible}
  onCancel={handleModalClose}
  aria-labelledby="kpi-details-modal"
  aria-describedby="modal-description"
>
  <Box className="report-modal-content" >
  <h2 className="self-title"> 
      {reportType === "Non-Compliance Report" && "Non-Compliance Report"}
      {reportType === "Year-End Rating" && "Year-End Rating Report"}
      {reportType === "Overall Rating" && "Overall Rating Report"}
      {reportType === "Manager Review Status" && "Manager Review Status Report"}
      {reportType === "Self-Assessment Status" && "Assessment Status Report"}
    </h2>
    {console.log("Checking tableDataModal array type before passing to table:", Array.isArray(tableDataModal))}
    {console.log("Passing to ReusableTable data:", tableDataModal)}

    {Array.isArray(tableDataModal) && tableDataModal.length > 0 ? (
      <ReusableTable
        data={tableDataModal || []} // Ensure it's always an array
        count={count}
        offset={offset}
        setOffset={setOffset}
        limit={limit}
        setSearchValue={setSearchValue}
        heading={
          reportType === "Non-Compliance Report"
            ? ["S.No", "Employee Code", "First Name", "Compliance Status"]
            : reportType === "Year-End Rating"
            ? ["S.No", "Employee Code", "First Name", "Q1 Rating", "Q2 Rating", "Q3 Rating", "Q4 Rating","Year-End Rating","Final Hr Rating"]
            : reportType === "Overall Rating"
            ? ["S.No", "Employee Code", "First Name", "Cycle Name", "Overall Rating"]
            : reportType === "Manager Review Status"
            ? ["S.No", "Employee Code", "First Name", "Cycle Name", "Review Status"]
            : reportType === "Self-Assessment Status"
            ? ["S.No", "Employee Code", "First Name", "Cycle Name", "Assessment Status"]
            : [] // Default heading if no match
        }      />
    ) : (
        <ReusableTable
        data={ []} // Ensure it's always an array
        count={count}
        offset={offset}
        setOffset={setOffset}
        limit={limit}
        setSearchValue={setSearchValue}
        heading={
          reportType === "Non-Compliance Report"
            ? ["S.No", "Employee Code", "First Name", "Compliance Status"]
            : reportType === "Year-End Rating"
            ? ["S.No", "Employee Code", "First Name", "Q1 Rating", "Q2 Rating", "Q3 Rating", "Q4 Rating","Year-End Rating","Final Hr Rating"]
            : reportType === "Overall Rating"
            ? ["S.No", "Employee Code", "First Name", "Cycle Name", "Overall Rating"]
            : reportType === "Manager Review Status"
            ? ["S.No", "Employee Code", "First Name", "Cycle Name", "Review Status"]
            : reportType === "Self-Assessment Status"
            ? ["S.No", "Employee Code", "First Name", "Cycle Name", "Assessment Status"]
            : [] // Default heading if no match
        }      />
    )}

    {/* Buttons Section */}
    {/* <div className="report-modal-buttons">
      <Button
        onClick={() => handleModalClose(false)}
        className="report-cancelButton"
      >
        Close
      </Button>
    </div> */}
    <Grid item xs={12} sm={2} md={2} lg={2}  style={{ textAlign: 'right', padding: '20px',  }}>
                            <Button sx={{ marginLeft: '20px !important' }}  className="cancelButton" onClick={closeModal}>Close</Button>
                        </Grid>

    
  </Box>
  
</Modal>


  </>
    

    
  );
};

export default ManagerReport;